import { get, post } from 'helpers/api';

export async function getMerge(propertyIds: number[]): Promise<any> {
  return get(`/research/properties/merge.json?property_ids=[${propertyIds.join(',')}]`);
}

export async function postMerge(
  propertyIds: number[],
  mappings: Record<string, number | null>
): Promise<any> {
  return post('/research/properties/merge.json', {
    property_ids: propertyIds,
    mappings
  });
}
